import { useEffect, useCallback } from 'react';

const useScrollClose = (isOpen, dropdownRef, onClose) => {
    const handleScroll = useCallback((e) => {
        if (dropdownRef.current?.contains(e.target)) {
            return;
        }

        if (onClose) onClose();
        
    }, [dropdownRef, onClose]);

    useEffect(() => {
        if (!isOpen || !onClose) return;

        window.addEventListener('scroll', handleScroll, { capture: true, passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll, { capture: true, passive: true });
        };
    }, [isOpen, handleScroll, onClose]);
};

export default useScrollClose;